export default "__VITE_ASSET__DhJ_FO3v__"